import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DeviceList from 'components/DeviceList/DeviceList';
import useDevicesSearch, { DeviceSortLabel } from 'functions/hooks/useDevicesSearch';
import { defaultSortOptions } from 'pages/Agent/menuLinks';
import CircularProgress from '@mui/material/CircularProgress';
import { agentMgtDevicesFilters } from 'pages/Agent/navigation';
import MgtDeviceCard from 'components/MgtDeviceCard/MgtDeviceCard';
import FilterNavigation from 'components/FilterNavigation/FilterNavigation';
import Pagination from 'components/Pagination/Pagination';

export default function AllMgtDevices() {

  const navigate = useNavigate();
  const [submittedQuery, setSubmittedQuery] = useState('');
  const [sort, setSort] = useState<DeviceSortLabel>('Latest');

  const {
    devices,
    loading,
    error,
    pageIndex,
    hasNext,
    hasPrev,
    next,
    prev,
  } = useDevicesSearch({ query: submittedQuery, sort, pageSize: 10 });

  return (
    <>
      <FilterNavigation
        filters={agentMgtDevicesFilters}
        sortOptions={defaultSortOptions}
        searchMode='submit'
        searchButtonLabel='Search'
        hideExtraOnMobile
        onSearchSubmit={(text) => setSubmittedQuery(text?.trim() || '')}
        onSortChange={(label) => setSort(label as DeviceSortLabel)}
      />
      <DeviceList>
        {loading && (
          <div className='device-list__loader'>
            <CircularProgress />
          </div>
        )}
        {!loading && error && (
          <div className='device-list__error' role='alert'>{error}</div>
        )}
        {!loading && !error && devices.map((device) => (
          <MgtDeviceCard key={device.id} device={device} onClick={() => navigate(`/agent/mgt-devices/${device.id}`)} />
        ))}
      </DeviceList>
      {!loading && !error && (
        <Pagination
          pageIndex={pageIndex}
          hasPrev={hasPrev}
          hasNext={hasNext}
          onPrev={prev}
          onNext={next}
        />
      )}
    </>
  );
}
